import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const ecwOrderApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEcwOrders: builder.mutation({
      query: (data: any) => ({
        url: `/ecw/getbyid?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    recordEcwOrder: builder.mutation({
      query: (data) => ({
        url: `/ecw/recordecwdata?tenantId=${data?.recordUsageInfo?.clientId ?? ''}`,
        method: "POST",
        body: data,
      }),
    }),
    getEcwOrderLogs: builder.mutation({
      query: (data: any) => ({
        url: `/ecw/get?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    revertEcwOrder: builder.mutation({
      query: (data: any) => ({
        url: `/ecw/revertecworder?${getFilters(data)}`,
        method: "PATCH",
      }),
    }),
    getEcwPatients: builder.mutation({
      query: (data: any) => ({
        url: `/ecw/getecwpatients?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    createEcwPatientFromFhir: builder.mutation({
      query: (data: any) => ({
        url: `/ecw/createpatientfromfhir`,
        method: "POST",
        body: data,
      }),
    }),
    getAllEcwOrdersByPatientId: builder.mutation({
      query: (data: any) => ({
        url: `/ecw/getallecwordersbypatientid?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    saveAllEcwOrdersForPatient: builder.mutation({
      query: (data: any) => ({
        url: `/ecw/saveallecwordersforpatient?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getAllEncountersForPatient: builder.mutation({
      query: (data: any) => ({
        url: `/ecw/getallencountersforpatient?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    saveAllEcwOrdersByEncounterFromFhir: builder.mutation({
      query: ({ patientId, encounter, ...rest }: any) => ({
        url: `/ecw/saveallecwordersbyencounterfromfhir?patientId=${patientId}`,
        method: "POST",
        body: encounter !== undefined ? encounter : rest,
      }),
    }),
  }),
});


export const {
  useGetEcwOrdersMutation,
  useRecordEcwOrderMutation,
  useGetEcwOrderLogsMutation,
  useRevertEcwOrderMutation,
  useGetEcwPatientsMutation,
  useCreateEcwPatientFromFhirMutation,
  useGetAllEcwOrdersByPatientIdMutation,
  useSaveAllEcwOrdersForPatientMutation,
  useGetAllEncountersForPatientMutation,
  useSaveAllEcwOrdersByEncounterFromFhirMutation,
} = ecwOrderApiSlice;